var app = angular.module("leonardo");

var SectorListActions = function($scope, ngDialog) {
  $scope.addSector = function(){
    ngDialog.open({
      controller: 'SectorEditDialog',
      templateUrl: 'views/templates/dialog/admin/fields/sector.html',
      data: {
        sector: null
      }
    });
  };
};

app.controller('SectorListActions', ['$scope', 'ngDialog', SectorListActions]);
